import React from 'react';
import { SwiperOptions } from 'swiper';
import swiperService from 'plugins/swiperService';
import Item from 'components/SliderGame/Item';
import NumberPagination from 'components/NumberPagination';
import { IProps, IState } from './types';

class SliderGame extends React.Component<IProps, IState> {
  static Item = Item as typeof Item;
  private sliderInstance: any;

  static defaultProps = {
    navigation: true,
    pagination: true
  };

  readonly state: IState = {
    activeIndex: 0
  };

  componentDidMount () {
    this.setUpSlider();
    this.getSliderActiveIndex();
  }

  componentWillUnmount () {
    this.destroySlider();
  }

  /**
   * @description 設置 Slider
   */
  setUpSlider = () => {
    const { name, config } = this.props;
    const container = `.${name}`;
    const options: SwiperOptions = {
      slidesPerView: 1,
      speed: 750,
      spaceBetween: 50,
      navigation: {
        nextEl: `#${name}-next-btn`,
        prevEl: `#${name}-prev-btn`
      },
      ...config
    };
    this.sliderInstance = swiperService.instance(container, options);
  }

  /**
   * @description 銷毀 Slider
   */
  destroySlider = () => {
    this.sliderInstance.destroy(true, true);
  }

  /**
   * @description 根據 Slider Active Index 變更，更新 State
   */
  getSliderActiveIndex = () => {
    this.sliderInstance.on('slideChange', () => {
      this.setState(state => ({ ...state, activeIndex: this.sliderInstance.realIndex }));
    });
  }

  /**
   * @description 處理頁面 onClick 執行的事件
   * @param pageIndex 頁面 index
   */
  handlePageClick = (pageIndex: number) => {
    if (this.sliderInstance) {
      this.sliderInstance.slideTo(pageIndex);
    }
  }

  render () {
    const { name, children, navigation, pagination } = this.props;
    return (
      <>
        {/* 手機版以三方套件 swiper 呈現抽獎列表 */}
        <div className="swiper">
          {/* swiper-container 後綴 name，以利功能操作 */}
          <div className={`swiper-container ${name}`}>
            <div className="swiper-wrapper">
              {children}
            </div>
          </div>
          {navigation && (
            <>
              <button type="button" id={`${name}-prev-btn`} className="swiper-button-prev button prev">
                <img
                  className="img"
                  src={require('assets/images/chevron-left-square.png')}
                  alt="previus"
                />
              </button>
              <button type="button" id={`${name}-next-btn`} className="swiper-button-next button next">
                <img
                  className="img"
                  src={require('assets/images/chevron-right-square.png')}
                  alt="next"
                />
              </button>
            </>
          )}
        </div>
        {/* 手機版分頁 */}
        {pagination && (
          <div className="swiperPagination">
            <NumberPagination
              activeIndex={this.state.activeIndex}
              totalPage={this.props.totalPage}
              onPageClick={(pageIndex: number) => this.handlePageClick(pageIndex)}
            />
          </div>
        )}
      </>
    );
  }
}

export default SliderGame;
